import { Navigate } from 'react-router-dom';
import { useRole } from '../../contexts/RoleContext';
import { ReactElement } from 'react';

export default function AdminRoute({ children }: { children: ReactElement }) {
  const { role, loading } = useRole();

  if (loading) {
    return <p>Loading...</p>; // you can swap this for a spinner later
  }

 return (role === 'admin' || role === 'super_admin') ? children : <Navigate to="/dashboard" replace />;
}
